module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.966a5f3d.mp3";